<template>
  <div class="container">
    <div class="BigImg"></div>
    <div class="div-pad">芯片</div>
    <div class="centerall">
      <img
        src="@/assets/ecologicalCooperation/xfpinpaion.png"
        alt="背景图"
        class="background-img"
      />
    </div>
    <div class="div-pad">智能终端和物联网</div>
    <div class="centerall">
      <img
        src="@/assets/ecologicalCooperation/xfpinpaitwo.png"
        alt="背景图"
        class="background-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    // 图片懒加载
    const imgs = document.querySelectorAll('.BigImg');
    imgs.forEach((img) => {
      img.addEventListener('load', () => {
        img.classList.add('loaded');
      });
    });
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.BigImg {
  width: 100%;
  height: 353px;
  background-size: cover; /* 背景图片铺满整个 div */
  background-image: url('@/assets/ecologicalCooperation/xfsthz.png');
  position: relative;
}
.centerall {
  position: relative;
  width: 100%;
  max-width: 1272px;
  height: 455px;
  overflow: hidden;
}
.div-pad {
  padding: 20px;
  font-size: 18px;
}
@media (max-width: 768px) {
  .BigImg {
    height: 99px; /* 降低高度适配小屏 */
    background-position: center;
  }

  .centerall {
    width: 100%;
    max-width: 100%;
    height: 150px;
    margin-top: 10px;
  }
  .div-pad {
    padding: 10px;
    font-size: 18px;
  }
  .container {
    padding: 0 10px;
  }
}
</style>
